import { Box, Container, Grid, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import VSNTypography from "../../shared/VSNTypography";
import shape8 from "../../assets/landing/svg/shape8.svg";
import shape9 from "../../assets/landing/svg/shape9.svg";
import shape10 from "../../assets/landing/svg/shape10.svg";
import shape11 from "../../assets/landing/svg/shape11.svg";
import sucessTrue from "../../assets/landing/svg/sucessTrue.svg";
import ContactEmailBg from "../../assets/landing/png/contact-email-bg.png";
import ControlForm from "../../shared/form/ControlForm";
import VSNButton from "../../shared/VSNButton";
import VSNImage from "../../shared/VSNImage";
import { contactUsContainer } from "../../container/contactUs.container";
import VSNErrorMessage from "../../shared/VSNErrorMessage";

const useStyles = makeStyles((theme) => ({
  emailSection: {
    position: "relative",
    overflow: "hidden",
    backgroundImage: `url(${ContactEmailBg})`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "repeat-x",
    [theme.breakpoints.down("sm")]: {
      margin: "0px",
    },
    "& p": {
      // fontSize: 24,
      marginBottom: 20,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
      [theme.breakpoints.down("xsm")]: {
        fontSize: 16,
      },
    },
    "& span": {
      fontSize: 24,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
      [theme.breakpoints.down("xsm")]: {
        fontSize: 16,
      },
    },
    "& .MuiButtonBase-root": {
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  },
  successIconImg: {
    margin: "0 auto",
    display: "table",
  },
  welcomeImage: {
    margin: "0 auto",
    display: "table",
    position: "relative",
    zIndex: 9,
    [theme.breakpoints.down("xlg")]: {
      maxWidth: "30%",
    },
    [theme.breakpoints.down("xsm")]: {
      maxWidth: "20%",
    },
  },
  shape8: {
    left: "5%",
    top: "10%",
    width: 100,
  },
  shape9: {
    left: "30%",
    top: "0%",
    width: 100,
  },
  shape10: {
    left: "60%",
    top: "5%",
    width: 100,
  },
  shape11: {
    right: "5%",
    top: "0%",
    width: 100,
  },
  spacing: {
    padding: "60px 0",
    [theme.breakpoints.down("md")]: {
      padding: "50px 0",
    },
  },
  sectionShape: {
    position: "absolute",
    zIndex: -1,
    [theme.breakpoints.down("smd")]: {
      display: "none",
    },
  },
  ContectUsMailModal: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "885px",
      },
    },
  },
  contactFormBox: {
    "& .MuiFormControl-root": {
      "& .MuiInputBase-root": {
        "& .MuiInputBase-input": {
          padding: 10,
          borderRadius: 8,
          backgroundColor: "white",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: `1px solid #CBCBCF`,
        },
      },
    },
  },
}));

const ContectUsMailModalForm = () => {
  const classes = useStyles();
  const {
    handleMobileChange,
    handleCreateContact,
    handleChange,
    formPath,
    contactUs,
    createContactLoader,
    contactUsAttribute,
    isMailSucess,
    formErrors,
  } = contactUsContainer();

  return (
    <>
      {!isMailSucess ? (
        <Stack className={`${classes.emailSection} ${classes.spacing}`}>
          <Container maxWidth="md">
            <Box
              sx={{
                paddingX: { sm: "10px", md: "30px" },
                paddingY: { sm: "10px", md: "30px" },
              }}
            >
              <VSNTypography
                color="secondary.darkGrey"
                variant="h4"
                textAlign="center"
                mb={2}
                fontWeight={700}
                fontSize={{ xlg: 46, lg: 35, xs: 26 }}
              >
                Get Early Access to Vāsanā.
              </VSNTypography>
              <VSNTypography
                color="secondary.darkGrey"
                variant="h4"
                textAlign="center"
                mb={2}
                fontWeight={700}
                fontSize={{ xlg: 28, lg: 22, xs: 16 }}
              >
                Register for our free public beta launch.
              </VSNTypography>

              <VSNTypography
                color="var(--gray)"
                variant="h4"
                textAlign="center"
                mb="40px"
                fontWeight={400}
                fontSize={{ xlg: 18, lg: 16, xs: 14 }}
              >
                Be among the first to use Vāsanā! Experience how Vāsanā’s
                cutting-edge enhances well-being, fosters happiness, and helps
                you thrive.
              </VSNTypography>

              <form onSubmit={handleCreateContact}>
                <Stack
                  direction={{ sm: "column", md: "row" }}
                  alignItems="center"
                  className={classes.contactFormBox}
                  gap={{ sm: 0, md: 2 }}
                >
                  {contactUsAttribute?.map(({ label, value }, index) => (
                    <Box key={index} width="100%">
                      {value?.map(
                        (
                          {
                            isRequired,
                            label,
                            errorMessage,
                            name,
                            value,
                            getValBy,
                            md,
                            ...attribute
                          },
                          index
                        ) => (
                          <Stack key={index} mb={{ xs: 2, md: 0 }}>
                            <ControlForm
                              {...{
                                ...attribute,
                                elementId: index,
                                label,
                                name,
                                handleMobileChange,
                                onChange: handleChange,
                                value: contactUs?.[name],
                              }}
                            />
                            <VSNErrorMessage
                              {...{
                                formError: formErrors?.[name],
                                errorMessage,
                              }}
                            />
                          </Stack>
                        )
                      )}
                    </Box>
                  ))}

                  <VSNButton isLoading={createContactLoader} type="submit">
                    Submit
                  </VSNButton>
                </Stack>
              </form>
            </Box>
          </Container>
          <VSNImage
            src={shape8}
            alt="shape"
            className={`${classes.shape8} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape9}
            alt="shape"
            className={`${classes.shape9} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape10}
            alt="shape"
            className={`${classes.shape10} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape11}
            alt="shape"
            className={`${classes.shape11} ${classes.sectionShape}`}
          />
        </Stack>
      ) : (
        <Stack className={`${classes.emailSection} ${classes.spacing}`}>
          <Container maxWidth="lg">
            <Box
              sx={{
                paddingX: { sm: "10px", md: "30px" },
                paddingY: { sm: "10px", md: "30px" },
              }}
            >
              <Box>
                <VSNImage
                  className={classes.successIconImg}
                  src={sucessTrue}
                  alt="shape"
                />
              </Box>
              <VSNTypography
                color="secondary.darkGrey"
                variant="h4"
                textAlign="center"
                mb={2}
                fontWeight={700}
                fontSize={{ xlg: 46, lg: 35, xs: 26 }}
              >
                Thank You for Signing Up for Vāsanā
              </VSNTypography>
              <VSNTypography
                color="secondary.darkGrey"
                variant="h4"
                textAlign="center"
                mb={2}
                fontWeight={700}
                fontSize={{ xlg: 28, lg: 22, xs: 16 }}
              >
                {`You're on the list for our free public beta launch.`}
              </VSNTypography>

              <VSNTypography
                color="var(--gray)"
                variant="h4"
                textAlign="center"
                fontWeight={400}
                fontSize={{ xlg: 18, lg: 16, xs: 14 }}
              >
                We can’t wait for you to experience how Vāsanā can enhance your
                well-being and happiness and help you thrive.
              </VSNTypography>
            </Box>
          </Container>
          <VSNImage
            src={shape8}
            alt="shape"
            className={`${classes.shape8} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape9}
            alt="shape"
            className={`${classes.shape9} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape10}
            alt="shape"
            className={`${classes.shape10} ${classes.sectionShape}`}
          />
          <VSNImage
            src={shape11}
            alt="shape"
            className={`${classes.shape11} ${classes.sectionShape}`}
          />
        </Stack>
      )}
    </>
  );
};

export default ContectUsMailModalForm;
